export * from './compiler';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
